import { createContext } from 'react'
import { IFormContext } from '../types/IFormContext'

export const FormLockModeContext = createContext<IFormContext>({
	lockMode: false,
	locked: false,
})
